










 

 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SetMeetingSettingsMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phaseTypes",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "disableAnonymity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "videoMeetingURL",
              "storageKey": null
            }
          ],
          "type": "RetrospectiveMeetingSettings",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SetMeetingSettingsPayload",
  "abstractKey": null
};

(node ).hash = "7d548576d72603b5c7687809f5fc9545";

export default node;
